import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineDocumentUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M8 9.575v-5.25M5.9 6.425l2.1-2.1 2.1 2.1M5.9 11.675h4.2"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M2.225 2.225v11.55c0 .58.47 1.05 1.05 1.05h9.45c.58 0 1.05-.47 1.05-1.05V4.85L10.1 1.175H3.275c-.58 0-1.05.47-1.05 1.05Z"
    />
  </svg>
);
export default SvgStreamlineDocumentUpload;
